<template>
  <div class="box02-body-detail-content" id="note-content"
    style="height:calc(100vh - 84px);"
    @scroll="handleScrollChild"
  >
    <FontawesomeIcon v-if="detail.title === '' || note.loading.detail" :icon="['fal','spinner-third']" size="2x" class="mt100 icn fa-spin" />
    <template v-else>
      <div class="box02-body-detail-content-info">
        <p class="title">
          <span v-if="detail.title" class="title-text">
            <template v-for="(string, stIndex) in detail.title.split(regExp)">
              <span v-if="keywordSplit.includes(string.toLowerCase())" class="yellow" :key="'title_' + stIndex">{{string}}</span>
              <template v-else>{{string}}</template>
            </template>
          </span>
          <span v-if="detail.alert_num > 10" class="title-num"><strong>!</strong> (9+)</span>
          <span v-else-if="detail.alert_num > 0" class="title-num"><strong>!</strong> ({{detail.alert_num}})</span>
        </p>
        <p class="sup">
          作成日：{{formatDate(detail.created)}}<span class="sup-row">更新日：{{formatDate(detail.modified)}}<template v-if="detail.modified_user_name">（更新者：{{detail.modified_user_name}}）</template></span>
        </p>
        <p class="sup prof">
          作成者：{{detail.create_user_name}}
          <span v-if="detail.user_file_id > 0" class="prof-img" :style="[detail.image && {backgroundImage : 'url(' + detail.image + ')'}]"></span>
          <span v-else class="prof-img no-image">{{detail.create_user_name.slice(0, 1)}}</span>
        </p>
        <p class="sup" 
          v-if="detail.share_type === 2 && (detail.share_classification === 21 || detail.share_classification === 22)">
          共有：<a @click="share.openNoteUserPermissionsList"
            class="txt-blue" 
            role="button"><template v-if="detail.share_classification === 21">閲覧権限のみ</template><template v-else-if="detail.share_classification === 22">編集権限あり</template></a>
        </p>
        <div v-if="state.isTagAreaShown && detail.tags.length > 0" class="tags">
          <div v-for="(tag, index) in detail.tags" :key="'tag_' + index" class="tag">
            <div class="tag-wrap">
              <span class="tag-text">{{tag.name}}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="box02-body-detail-content-body">
        <template v-for="list in detail.lists">
          <!-- 見出し -->
          <h3 v-if="list.type === 0 && list.content" :key="'hdg_' + list.id" class="note-content-hdg">
            <template v-for="(string, stIndex) in list.content.split(regExp)">
              <span v-if="keywordSplit.includes(string.toLowerCase())" class="yellow" :key="'hdg_' + list.id + '_' + stIndex">{{string}}</span>
              <template v-else>{{string}}</template>
            </template>
          </h3>

          <!-- 本文 -->
          <p v-else-if="list.type === 1 && list.content" :key="'parag_' + list.id" class="note-content-parag">
            <template v-for="(string, stIndex) in list.content.split(regExp)">
              <span v-if="keywordSplit.includes(string.toLowerCase())" class="yellow" :key="'parag_' + list.id + '_' + stIndex">{{string}}</span>
              <template v-else>{{string}}</template>
            </template>
          </p>

          <!-- ナレッジ -->
          <div v-else-if="list.type === 2" :key="'knowledge_' + list.id" class="note-content-block">
            <template v-if="list.knowledge.deleted === 1">
              <p class="note-content-block-text">
                閲覧できなくなりました。
              </p>
              <p class="note-content-block-title is-inactive">{{list.knowledge.name}}</p>
            </template>
            <template v-else-if="list.knowledge.auth_message">
              <p class="note-content-block-text">
                {{list.knowledge.auth_message}}
              </p>
              <p class="note-content-block-title is-inactive">{{list.knowledge.name}}</p>
            </template>
            <router-link v-else :to="'/pc/knowledge-detail/' + list.knowledge.id" class="note-content-block-title">
              {{list.knowledge.name}}
            </router-link>
            <ul class="note-content-block-sup">
              <li><span class="category-item">最新ナレッジ</span><span class="category-item">{{list.knowledge.knowledge_type_name}}</span></li>
              <li>{{formatDate(list.knowledge.created)}}</li>
            </ul>
          </div>

          <!-- QA -->
          <div v-else-if="list.type === 3" :key="'qa_' + list.id" class="note-content-block">
            <template v-if="list.qa.deleted === 1">
              <p class="note-content-block-text">
                閲覧できなくなりました。
              </p>
              <p class="note-content-block-title is-inactive">
                {{list.qa.name}}
              </p>
            </template>
            <template v-else-if="list.qa.auth_message">
              <p class="note-content-block-text">
                {{list.qa.auth_message}}
              </p>
              <p class="note-content-block-title is-inactive">
                {{list.qa.name}}
              </p>
            </template>
            <a v-else :href="'/lc/app/pc/qa-detail-pdf/' + note.currentId + '/' + list.id + '/' + (list.qa.latest_id !== 0 ? list.qa.latest_id : list.qa.id)" target="_blank" class="note-content-block-title">
              {{list.qa.name}}
            </a>
            <ul class="note-content-block-sup">
              <li>QA・事例</li>
              <li>{{list.qa.book_name}}</li>
              <li v-if="list.qa.year !== 'マスターインデックス'">{{list.qa.year}}</li>
            </ul>
            <router-link
              v-if="list.qa.deleted !== 1 && !list.qa.auth_message"
              :to="'/pc/qa-detail/' + (list.qa.latest_id !== 0 ? list.qa.latest_id : list.qa.id)"
              class="note-content-block-link">最新のQ&amp;A・事例詳細はこちら</router-link>
          </div>

          <!-- 先例・判例 -->
          <div v-else-if="list.type === 4" :key="'pj_' + list.id" class="note-content-block">
            <template v-if="list.pj.deleted === 1">
              <p class="note-content-block-text">
                閲覧できなくなりました。
              </p>
              <p class="note-content-block-title is-inactive">
                {{list.pj.name}}
              </p>
            </template>
            <template v-else-if="list.pj.auth_message">
              <p class="note-content-block-text">
                {{list.pj.auth_message}}
              </p>
              <p class="note-content-block-title is-inactive">
                {{list.pj.name}}
              </p>
            </template>
            <a v-else :href="'/lc/app/pc/document-list/detail/' + (list.pj.latest_id !== 0 ? list.pj.latest_id : list.pj.id) + '/'" target="_blank" class="note-content-block-title">
              {{list.pj.name}}
            </a>
            <ul class="note-content-block-sup">
              <li>資料</li>
              <li>{{list.pj.book_name}}</li>
            </ul>
          </div>

        </template>
      </div>
    </template>

  </div>
</template>
<script>
import { defineComponent, reactive, computed } from '@vue/composition-api'
import { formatDate } from '@/util/common'
import { NoteDetailPart } from '@/logic/note/NoteDetailPart'

export default defineComponent({
  setup (props, context) {

    return {
      ...NoteDetailPart(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.box02-body {
  &-detail {
    transition: all .2s ease;
    width: 70%;
    border-left: 1px solid $color-line;
    &-content {
      border-top: 1px solid $color-line;
      overflow-y: auto;
      &-info {
        position: relative;
        padding: 40px;
        border-bottom: 1px solid $color-line;
        .title {
          margin-bottom: 16px;
          &-text {
            font-size: 2.4rem;
            color: $color-hdg;
            font-weight: bold;
            vertical-align: middle;
          }
          &-num {
            font-size: 1.2rem;
            font-weight: normal;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            width: 50px;
            color: $color-sup;
            margin-left: 8px;
            strong {
              font-size: 2.4rem;
              font-weight: bold;
              vertical-align: middle;
            }
          }
          // & + .sup {
          //   margin-right: 20px;
          //   padding-right: 20px;
          //   border-right: 1px solid $color-line;
          // }
        }
        .sup {
          margin-top: 8px;
          font-size: 1.4rem;
          color: $color-sup;
          display: flex;
          align-items: center;
          .prof-img {
            @include profileImage();
          }
          &.prof {
            margin-left: 0;
            // margin-right: 20px;
            padding-left: 0;
          }
          &-row {
            margin-left: 1em;
          }
        }
        .tags {
          margin-top: 8px;
        }
      }
      &-body {
        padding: 40px;
        overflow: auto;
        .is-preview-print & {
          height: auto!important;
        }
      }
    }
  }
  &.is-note-full {
    .box02-body-title {
      width: 0;
      visibility: hidden;
      opacity: 0;
    }
    .box02-body-detail {
      width: 100%;
    }
  }
}
.note-content {
  &-hdg {
    font-size: 2.4rem;
    font-weight: bold;
    color: $color-hdg;
    margin-bottom: 16px;
  }
  &-parag {
    font-size: 1.6rem;
    margin-bottom: 40px;
    color: $color-content;
    white-space: pre-wrap;
  }
  &-block {
    margin-bottom: 40px;
    &-title {
      color: $color-link;
      font-size: 2.0rem;
      font-weight: bold;
      margin-bottom: 8px;
      display: block;
      &:not(.is-inactive) {
        @include hoverOpacity;
      }
      &.is-inactive {
        color: $color-inactive;
        font-weight: normal!important;
      }
    }
    &-text {
      color: $color-content;
      font-size: 1.6rem;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      .icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        color: $color-sup;
        font-size: 2rem;
        font-weight: bold;
      }
    }
    &-link {
      display: block;
      color: $color-link;
      font-size: 1.6rem;
      margin-bottom: 12px;
      @include hoverOpacity;
    }
    &-sup {
      list-style: none;
      color: $color-sup;
      font-size: 1.4rem;
      margin-bottom: 8px;
      li {
        display: inline-block;
        margin-right: 20px;
      }
      .category-item:not(:last-child) {
        margin-right: 1em;
      }
    }
  }
}

</style>
